import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PrimaryCardWithCollection from 'Components/ComponentLibrary/Molecules/PrimaryCardWithCollection';
import fr from 'facet-rest';
import ResetButtonPicker from './ResetButtonPicker';

const styles = theme => ({
  root: {
    marginTop: theme.spacing(1),
  },
});

const BalanceTransferRolloverSection = ({
  className,
  classes,
  resource,
  itemCollection,
  title,
  handleAddBalanceTransfer,
  handleModifyBalanceTransfer,
  showResetButton,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <PrimaryCardWithCollection
        title={title || resource.attr('title')}
        resource={resource}
        onAdd={(handleAddBalanceTransfer && resource.relationship(fr.relationships.addBalanceTransfer.name)) ? () => handleAddBalanceTransfer(resource) : null}
        onEdit={(res) => handleModifyBalanceTransfer(res)}
        itemCollection={itemCollection || resource.attr('virtualAccounts')}
        getItemPrimaryText={(item) => item.attr('title')}
        getItemSecondaryText={(item) => (
          <>
            {item.attr('middleText')}
            <br />
            {item.attr('bottomText')}
          </>
        )}
        emptyListAlertTitle={'No Money Movement'}
      />
      {showResetButton && <ResetButtonPicker />}
    </Box>
  );
};

BalanceTransferRolloverSection.defaultProps = {
  className: '',
  itemCollection: null,
  handleAddBalanceTransfer: null,
  title: null,
  showResetButton: true,
};

BalanceTransferRolloverSection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  title: PropTypes.string,
  itemCollection: PropTypes.object,
  handleAddBalanceTransfer: PropTypes.func,
  handleModifyBalanceTransfer: PropTypes.func.isRequired,
  showResetButton: PropTypes.bool,
};

export default withStyles(styles)(BalanceTransferRolloverSection);
